<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <Breadcrumb crumbTitle="公益项目" crumbName="PROGRAMS" location="项目 > 项目列表"></Breadcrumb>
    <WtDataList
      v-model="data.list"
      :url="$url.project.list"
      :pageSize="6"
      :search="search"
      ref="projectRef"
    >
      <div slot="list" ref="list">
        <div class="project-box">
          <ul>
            <li v-for="(item,index) in data.list" :key="index">
              <router-link :to="{ name: 'projectInfo',query: { id: item.id,moduleId:$route.query.moduleId }}">
                <div class="act-top">
                  <img :src="item.cover_photo_text[0].path" v-if="item.cover_photo_text.length>0">
                </div>
                <div class="act-bottom">
                  <h3>{{item.name}}</h3>
                  <p>{{item.target}}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </WtDataList>
    <WtFooter></WtFooter>
  </div>
</template>
<script>
import webHeader from "../Public/header";
import Breadcrumb from "../Public/breadcrumb";
export default {
  components: {
    webHeader,
    Breadcrumb
  },
  data() {
    return {
      data: {},
      search: {
        fs:2
      },
    };
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
#app-project {
  width: 100%;
}
.project-box {
  max-width: 1300px;
  margin: 50px auto;
  > ul {
    display: flex;
    //justify-content: space-between;
    flex-wrap: wrap;
    > li {
      list-style: none;
      width: 400px;
      margin-right: 30px;
      //height: 440px;
      background-color: #ffffff;
      // box-shadow: 0px 6px 19px 0px rgba(11, 2, 5, 0.09);
      position: relative;
      transition: ease-out 0.6s;
      cursor: pointer;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      overflow: hidden;
      &:hover {
        background-color: #e83a16;
        box-shadow: 0px 6px 19px 0px rgba(11, 2, 5, 0.09);
        > a {
          .act-bottom { 
            > h3 {
              color: #fff;
            }
            > span {
              color: #fff;
            }
            > p {
              color: #ffbcae;
            }
          }
        }
        // border: solid 1px #ededed;
      }
      > a {
        .act-top {
          width: 100%;
          height: 260px;
          > img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }
        }
        .act-bottom {
          padding: 30px;
          transition: linear 0.6s;
          > p {
            font-size: 14px;
            font-weight: normal;
            color: #999999;
            line-height: 24px;
            margin-bottom: 22px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          > h3 {
            font-size: 18px;
            font-weight: 500;
            color: #333333;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap;
            /* 不换行 */
            text-overflow: ellipsis;
            /* 超出部分省略号显示 */
            margin-bottom: 12px;
          }
          > span {
            font-size: 15px;
            color: #333333;
          }
        }
      }
    }
  }
}
.page-box {
  max-width: 1300px;
  margin: 0 auto;
  margin-bottom: 50px;
  text-align: center;
}
.page-box /deep/ .el-pagination.is-background .btn-prev {
  background-color: #fff;
  border: solid 1px #cccccc;
  border-radius: 50%;
}
.page-box /deep/ .el-pagination.is-background .btn-next {
  background-color: #fff;
  border: solid 1px #cccccc;
  border-radius: 50%;
}
.page-box /deep/ .el-pagination.is-background .el-pager li {
  border-radius: 50%;
  background-color: #fff;
  border: solid 1px #cccccc;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #e83a16;
  border: solid 1px #e83a16;
}
</style>



// WEBPACK FOOTER //
// src/view/Project/list.vue